export enum RulePrivacyEnumerator {
  Private = 'private',
  Public = 'public'
}
